/** Client-side helpers for marketplace reward API payloads and header animation. */

/**
 * If an API response includes `marketplaceReward`, emit the header animation event.
 * @param {object} data response body (may be null)
 */
export function emitMarketplaceRewardFromResponse(data) {
  const reward = data?.marketplaceReward;
  if (!reward || typeof reward !== "object") return;
  const amount = Math.trunc(Number(reward.amount) || 0);
  if (amount <= 0) return;
  const balance =
    reward.balance != null ? Math.trunc(Number(reward.balance) || 0) : undefined;
  window.dispatchEvent(
    new CustomEvent("pb-marketplace-rewarded", {
      detail: {
        amount,
        balance,
        triggerId: reward.triggerId || null,
      },
    })
  );
  window.dispatchEvent(new CustomEvent("pb-marketplace-balance-changed"));
}

/** User-visible note after phase complete awards team members V-coins. */
export function describePhaseMarketplaceRewardResult(marketplacePhaseRewards) {
  const pr = marketplacePhaseRewards;
  if (!pr || typeof pr !== "object") return "";
  const count = Math.trunc(Number(pr.recipientCount) || pr.awarded?.length || 0);
  const amount = Math.trunc(Number(pr.amount) || 0);
  const phase = String(pr.completedPhase || "").trim();
  if (count <= 0 || amount <= 0) {
    if (phase && pr.triggerId) {
      return "No V-coin recipients were found for this phase (assign people on the project or configure email trigger roles).";
    }
    return "";
  }
  const phaseBit = phase ? `${phase} complete — ` : "";
  return `${phaseBit}V-coins awarded to ${count} team member${count === 1 ? "" : "s"}.`;
}

/**
 * If an API response includes `marketplaceClawback` (e.g. file removed), refresh the header balance.
 * @param {object} data response body (may be null)
 */
export function emitMarketplaceClawbackFromResponse(data) {
  const clawback = data?.marketplaceClawback;
  if (!clawback || typeof clawback !== "object") return;
  const amount = Math.trunc(Number(clawback.amount) || 0);
  if (amount <= 0) return;
  window.dispatchEvent(new CustomEvent("pb-marketplace-balance-changed"));
}

/** @deprecated use emitMarketplaceRewardFromResponse */
export function notifyMarketplaceBalanceChanged() {
  window.dispatchEvent(new CustomEvent("pb-marketplace-balance-changed"));
}
